"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-do-not-disturb.tsx
var DoNotDisturb = function DoNotDisturb(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M4.66732 8.66671H11.334V7.33337H4.66732V8.66671ZM8.00065 14.6667C7.07843 14.6667 6.21176 14.4917 5.40065 14.1417C4.58954 13.7917 3.88398 13.3167 3.28398 12.7167C2.68398 12.1167 2.20898 11.4112 1.85898 10.6C1.50898 9.78893 1.33398 8.92226 1.33398 8.00004C1.33398 7.07782 1.50898 6.21115 1.85898 5.40004C2.20898 4.58893 2.68398 3.88337 3.28398 3.28337C3.88398 2.68337 4.58954 2.20837 5.40065 1.85837C6.21176 1.50837 7.07843 1.33337 8.00065 1.33337C8.92287 1.33337 9.78954 1.50837 10.6007 1.85837C11.4118 2.20837 12.1173 2.68337 12.7173 3.28337C13.3173 3.88337 13.7923 4.58893 14.1423 5.40004C14.4923 6.21115 14.6673 7.07782 14.6673 8.00004C14.6673 8.92226 14.4923 9.78893 14.1423 10.6C13.7923 11.4112 13.3173 12.1167 12.7173 12.7167C12.1173 13.3167 11.4118 13.7917 10.6007 14.1417C9.78954 14.4917 8.92287 14.6667 8.00065 14.6667Z"
  }));
};

var _default = DoNotDisturb;
exports.default = _default;